// loading指定挂载
import Loading from './loading.vue';
import {createVNode,nextTick ,render} from "vue"
import { useZIndex } from 'element-plus/es/hooks/use-z-index/index.mjs';
const addClass = (el, cls) => {
  if (!el || !cls.trim())
    return;
   
  el.classList.add(... cls.split(" ").filter((item) => !!item.trim()));
};

const loadingDirective = {};
loadingDirective.install = Vue => {
  const toggleLoading = (el, binding) => {
    if (binding.value) {
     nextTick(() => {
        if (binding.modifiers.fullscreen) {
          const { nextZIndex } = useZIndex();
          el.maskStyle.zIndex = nextZIndex();
          insertDom(document.body, el, binding);
        } else {
            insertDom(el, el, binding);
        }
      });
    } else {
      el.instance.component.props.visible = false;
      setTimeout(() => {
        el.classList.remove('el-loading-parent--relative')
      }, 300);
    }
  };
  const insertDom = (parent, el, binding) => {
    if (  el.domInserted!==true) {
        Object.keys(el.maskStyle).forEach(property => {
        el.mask.style[property] = el.maskStyle[property];
      });

      if (el.originalPosition !== 'absolute' && el.originalPosition !== 'fixed') {
        addClass(parent, 'el-loading-parent--relative');
      }
      if (binding.modifiers.fullscreen && binding.modifiers.lock) {
        addClass(parent, 'el-loading-parent--hidden');
      }
      parent.appendChild(el.mask);
      nextTick(() => {
          el.instance.component.props.visible = true;
      });
      el.domInserted = true;
    } else {
      el.instance.component.props.visible = true;
    }
  };

  Vue.directive('cstloading', {
    beforeMount: function(el, binding) {
      const loadText = el.getAttribute('cstloading-text') || '正在拼命加载中';
     let mask = createVNode(Loading, {
      loadText:loadText,
      loadImg:require('@img/loading/loading.gif'),
       })
        let node = document.getElementById('my-cstloading');
        if(!node) {
            node = document.createElement('div', {id: 'my-cstloading'})
        }
        render(mask, node)
      el.instance = mask;
      el.mask = mask.el;
      el.maskStyle = {};
      binding.value && toggleLoading(el, binding);
    },

    updated: function(el, binding) {
      if (binding.oldValue !== binding.value) {
        toggleLoading(el, binding);
      }
    },

    unmounted: function(el, binding) {
      if (el.domInserted) {
        el.mask &&
        el.mask.parentNode &&
        el.mask.parentNode.removeChild(el.mask);
        toggleLoading(el, { value: false, modifiers: binding.modifiers });
      }
     
      el.mask && (el.mask=null)
    }
  });
};

export default loadingDirective;
